<ng-container *ngIf="loading; else viewTemplate">
  <div style="min-height: 50vh" fxLayout="row" fxLayoutAlign="center center">
    <uni-loader></uni-loader>
  </div>
</ng-container>

<ng-template #viewTemplate>
  <app-journal-header
    [blog]="blog"
    [canPublish]="canPublish"
    [wordCount]="wordCount"
    [imageCount]="imageCount"
    [embedCount]="embedCount"
    [next]="next"
    [lastSaved]="lastSaved"
    [user]="user"
    class="width-100">
  </app-journal-header>

  <div class="blog-container">
    <div fxLayout="column" class="blog-inner-container">
      <div fxLayout="row" class="blog-section">
        <div fxLayout="column" class="width-100">
          <form [formGroup]="blogForm">
            <textarea
              matInput
              placeholder="A great story is in your mind"
              maxlength="200"
              formControlName="title"
              class="font-title width-100"
              cdkTextareaAutosize>
            </textarea>

            <textarea
              matInput
              placeholder="All you have to do is pen it here and show the world"
              formControlName="tagline"
              class="font-subtitle width-100"
              maxlength="200"
              cdkTextareaAutosize>
            </textarea>
          </form>
          <div #editor></div>
        </div>
      </div>
      <div *ngIf="blog.references && blog.references.length > 0" class="blog-section">
        <hr style="border: 0; border-top: 10px dotted #545454; width: 45px; margin: 30px auto" />

        <div fxLayout="row">
          <section fxLayout="column" class="width-100 margin-bottom-15">
            <p class="font-lg font-bold" [ngStyle]="{ 'margin-top': mobileView ? '0px' : '24px' }">
              References
            </p>
            <div fxLayout="row" fxFlex="100">
              <div fxLayout="column" class="width-100">
                <div *ngFor="let reference of blog.references; index as i" style="margin: 4px 0">
                  <div
                    *ngIf="reference && reference.reference_type == 'PUBLICATION'"
                    fxLayout="row"
                    fxFlex="100"
                    class="reference-text">
                    <span class="sparro-grey-900 margin-auto">{{ i + 1 }})&nbsp;</span>
                    <div fxFlex="90" class="margin-auto">
                      <span
                        class="sparro-grey-900 font-bold"
                        *ngIf="reference.title"
                        style="padding-right: 6px; margin: auto 0"
                        >{{ reference.title }} -
                      </span>
                      <span
                        class="sparro-grey-900"
                        *ngIf="reference.volume"
                        style="padding-right: 6px; margin: auto 0"
                        ><i>{{ reference.volume }},</i></span
                      >
                      <span
                        class="sparro-grey-900"
                        *ngIf="reference.isbn"
                        style="padding-right: 6px; margin: auto 0"
                        >{{ reference.isbn }},</span
                      >
                      <span
                        class="sparro-grey-900"
                        *ngIf="reference.author"
                        style="padding-right: 6px; margin: auto 0"
                        >{{ reference.author | titlecase }}</span
                      >
                      <span
                        class="sparro-grey-900"
                        *ngIf="reference.publisher"
                        style="padding-right: 6px; margin: auto 0"
                        >[{{ reference.publisher | titlecase }}]</span
                      >
                    </div>

                    <div fxLayout="column" fxFlex="10" style="justify-content: flex-end">
                      <div class="right-icons" fxLayout="row" style="justify-content: flex-end">
                        <i
                          (click)="editReference(reference)"
                          class="reference-edit-icon icon-edit"></i>
                        <i
                          (click)="deleteReference(reference)"
                          class="reference-delete-icon icon-delete"></i>
                      </div>
                    </div>
                  </div>
                  <div
                    *ngIf="reference && reference.reference_type == 'WEBPAGE'"
                    fxLayout="row"
                    fxFlex="100"
                    class="reference-text">
                    <span class="sparro-grey-900 margin-auto">{{ i + 1 }})&nbsp;</span>
                    <div [fxLayout]="mobileView ? 'column' : 'row'" fxFlex="90">
                      <span class="sparro-grey-900 font-bold" style="margin: auto 0"
                        >{{ reference.title }} &nbsp;</span
                      >
                      <span class="sparro-grey-900" style="margin: auto 0"
                        >(<i> {{ reference.url }} </i>)</span
                      >
                    </div>

                    <div fxLayout="column" fxFlex="10" style="justify-content: flex-end">
                      <div class="right-icons" fxLayout="row" fxLayoutAlign="center center">
                        <i
                          (click)="editReference(reference)"
                          class="reference-edit-icon icon-edit"></i>
                        <i
                          (click)="deleteReference(reference)"
                          class="reference-delete-icon icon-delete"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- <div #editor class="border-radius-1 font-sm"></div> -->
